import {DebounceSelectOptionProps} from "../../../components/UI/AntCustom/DebounceSelect";
import {
  UserAccountApiFlyCompanyListRequest,
  PageModel
} from "../../../proto/generated/api_entities_pb";
import {InitialPage} from "../../constans/pagination/pagination";
import {PageModelLimits} from "../../constans/pagination/pageModelLimits";
import {API} from "../../../API/API";

export async function fetchOperators(search?: string): Promise<DebounceSelectOptionProps[]> {
  const req = new UserAccountApiFlyCompanyListRequest()
    .setQuery(search ?? "")
    .setPagemodel(
      new PageModel().setPage(InitialPage).setLimit(PageModelLimits.FlyCompanies)
    );

  const companyList = await API.getFlyCompanyList(req);

  return companyList.getFlycompaniesList().map(company => {
    return {
      key: company.getCompanyid(),
      label: company.getCompanyname(),
      value: company.getCompanyid(),
    }
  });
}


